module.exports = __webpack_public_path__ + "static/media/placeholder.bb03e57a.png";